import { apiClass } from '@/base/class/api.class'
import { ENDPOINTS } from '@/base/const/endpoints.const'
import { ToolsClass } from '@/base/class/tools.class'
import { ADS_BANNER_SIZE, ADS_SOURCE_ID } from '@/base/const/ads.const'

const state = {
  isAdDataLoaded: false,
  data: null,
  size: ADS_BANNER_SIZE.desktop,
  showCommercialBreake: false,
  commercialBreakClosed: false,
  serviceId: null,
  email: null,
}
const mutations = {
  SET_ADS_DATA(state, data) {
    state.data = data
  },
  SET_ADS_SIZE(state, value) {
    state.size = value
  },
  SET_ADS_SHOW_COMMERCIAL_BREAKE(state, value) {
    state.showCommercialBreake = value
  },
  SET_ADS_COMMERCIAL_BREAK_CLOSED(state, value) {
    state.commercialBreakClosed = value
  },
  SET_ADS_IS_AD_DATA_LOADED(state, value) {
    state.isAdDataLoaded = value
  },
  SET_ADS_SERVICE_ID(state, value) {
    state.serviceId = value
  },
  SET_ADS_EMAIL(state, value) {
    state.email = value
  },
}
const actions = {
  getAdsBanners({ commit }, { serviceId, transRemoteID, paywayId, email }) {
    commit('SET_ADS_SERVICE_ID', serviceId)
    commit('SET_ADS_EMAIL', email)
    const endpoint = `${ENDPOINTS.ads.getBannersList}?serviceId=${serviceId}&sourceId=${ADS_SOURCE_ID}&paywayId=${paywayId}&email=${email}&transaction_id=${transRemoteID}`
    return apiClass
      .getAds(endpoint)
      .then((response) => {
        commit('SET_ADS_DATA', response.body)
        if (ToolsClass.isMobileScreenSize()) {
          commit('SET_ADS_SIZE', ADS_BANNER_SIZE.mobile)
        }
        return Promise.resolve()
      })
      .catch((error) => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_ADS_IS_AD_DATA_LOADED', true)
      })
  },
  sendAdsBannerViewConfirmation({ commit, state }, { creationId, transRemoteID }) {
    const endpoint = `${ENDPOINTS.ads.sendBannerViewConfirmation}?serviceId=${state.serviceId}&creationId=${creationId}&email=${state.email}&transaction_id=${transRemoteID}`
    return apiClass.getAds(endpoint)
  },
}
const getters = {
  isAdsBannerDataSet(state) {
    return !!state.data && Array.isArray(state.data) && state.data.length
  },
  isCommercialBreakDataSet(state) {
    if (!state.data || !state.data.length) {
      return false
    }
    return !!state.data.find((banner) => {
      return banner.targetDevice === state.size && banner.commercialBreak === true
    })
  },
  getBannerToDisplay(state) {
    if (!state.data || !state.data.length) {
      return false
    }
    return state.data.find((banner) => {
      return banner.targetDevice === state.size && banner.commercialBreak === false
    })
  },
  getCommercialBreak(state) {
    if (!state.data || !state.data.length) {
      return false
    }
    return state.data.find((banner) => {
      return banner.targetDevice === state.size && banner.commercialBreak === true
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
